import React from 'react';
import { Modal, Button } from './ui';

/**
 * Backwards-compatible ConfirmDialog wrapper around the Modal primitive.
 *
 * Public props (unchanged):
 *   isOpen, onConfirm, onCancel, title, message,
 *   confirmText, cancelText, confirmButtonStyle ('primary' | 'danger' | 'success')
 * Plus `overSlideInPanel` for callers rendering from inside a slide-in panel,
 * which otherwise covers this dialog entirely — see Modal.
 */
const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonStyle = 'primary',
  overSlideInPanel = false,
}) => {
  // Map legacy `confirmButtonStyle` to Button variants.
  const confirmVariant =
    confirmButtonStyle === 'danger'
      ? 'danger'
      : confirmButtonStyle === 'success'
        ? 'primary'
        : 'primary';

  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      title={title}
      size="sm"
      overSlideInPanel={overSlideInPanel}
      actions={
        <>
          {cancelText && (
            <Button variant="secondary" onClick={onCancel}>
              {cancelText}
            </Button>
          )}
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </>
      }
    >
      <p style={{ margin: 0 }}>{message}</p>
    </Modal>
  );
};

export default ConfirmDialog;
